import { useEffect, useState } from 'react';
import { NARROW_ROW_WIDTH } from './constants';


export const useNarrowRow = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [narrow, setNarrow] = useState(false);

  useEffect(() => {
    if (!element) return;

    const measure = () => setNarrow(element.clientWidth <= NARROW_ROW_WIDTH);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return { ref: setElement, narrow };
};
